export default "__VITE_ASSET__AVzC4NeT__"